<footer class="container-fluid footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <img [src]="env.assetsPath + '/img/drct-logo.png'" class="logo" alt="DRCT Logo" title="DRCT Logo">
      </div>
      <div class="col-lg-4 col-md-6 quick-links">
        <h3>Quick Links</h3>
          <ul>
            <li><a routerLink="history">History</a></li>
            <li><a routerLink="ministries">Ministries</a></li>
            <li><a routerLink="prayer-request">Prayer Request</a></li>
            <li><a routerLink="brochure">Brochures</a></li>
            <li><a routerLink="photo-gallery">Photo Gallery</a></li>
            <li><a routerLink="contact-us">Contact Us</a></li>
          </ul>
      </div>
      <div class="col-lg-4 col-md-6 contact-info">
        <h3>Get in touch</h3>
          <ul>
            <li><span class="icon icon-mail"></span>
              <a href="mailto:{{ enquiry_email }}">{{ enquiry_email }}</a>
            </li>
            <li><span class="icon icon-phone"></span>
              <a href="tel:+16479494932">+1 (647) 949-4932</a>
            </li>
            <li><span class="icon icon-phone"></span>
              <a href="tel:+16476601314">+1 (647) 660-1314</a>
            </li>
            <li><span class="icon icon-map-pin"></span> 
              <a href="https://google.com/maps/place/69+William+St,+Toronto,+ON+M9N+2G6" target="_blank" rel="noopener">69 William Street, Toronto, ON M9N 2G6</a></li>
          </ul>
      </div>
    </div>
  </div>
  <div class="container sub-footer">
    <div class="row">
      <div class="col-md-6">
        <p>&copy; {{ year }} Divine Retreat Centre Toronto. All Rights Reserved.</p>
      </div>

      <div class="col-md-6 sub-footer__social">
        <a href="https://facebook.com/divineretreatcentretorontoca/" target="_blank">
            <span class="icon icon-facebook2"></span>
        </a>
        <a href="https://youtube.com/c/DivineRetreatCentreToronto/" target="_blank">
            <span class="icon icon-youtube"></span>
        </a>
        <a href="https://www.instagram.com/p/CzMQilnrzZo/" target="_blank">
            <span class="icon icon-instagram"></span>
        </a>
      </div>
    </div>
  </div>
</footer>

